/** @jsxImportSource @emotion/react */
import type { BestScorer } from 'modules/main/domain/types/types';
import React from 'react';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import Text from 'ud-ui/components/text';
import * as S from './styles';

interface IScorersProps extends DivProps {
  scorers: BestScorer[];
}

function Scorers(props: IScorersProps) {
  const { scorers, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      {scorers.map((scorer) => {
        const nameParts = scorer.name.split(' ');
        const name = `${nameParts[0]} ${nameParts[1][0]}.`;

        return (
          <S.ScorerBlock key={scorer.id}>
            <S.Avatar>
              <img src={scorer.image} alt="img" />
            </S.Avatar>
            <S.Info className="truncate">
              <Text isNew type="subtitle-4" className="truncate" color={theme.colors.Gray}>
                {name}
              </Text>
              <Text isNew type="subtitle-3" color={theme.colors.DarkYellow}>
                {scorer.goals} голов
              </Text>
            </S.Info>
          </S.ScorerBlock>
        );
      })}
    </S.MainBlock>
  );
}

export default Scorers;
